import { UntypedFormGroup } from "@angular/forms";
import { PaginatedData } from "../models/filter.model";


export function mapPaginatedModel<T, U>(res: { pagination: any, data: any[] },
  mapperCallback?: (n: U) => T): PaginatedData<T> {
  const data = res?.data ?? [];
  return {
    totalRecords: res?.pagination ? res.pagination.total : data.length,
    data: data.map(c => mapperCallback ? mapperCallback(c) : c)
  };
}


export function isFieldValidfn(formGroup: UntypedFormGroup, field: string) {
  return (formGroup && !formGroup?.get(field)?.disabled && !formGroup?.get(field)?.valid && (formGroup?.get(field)?.touched || !formGroup?.get(field)?.pristine)) ?? false;
}


export function guid() {
  function s4() {
    return Math.floor((1 + Math.random()) * 0x10000)
      .toString(16)
      .substring(1);
  }
  return s4() + s4() + '-' + s4() + '-' + s4() + '-' +
    s4() + '-' + s4() + s4() + s4();
}

